export default (str = "") => {
    return (str.toString() || "")
        .split(" ")
        .filter(i => i)
        .map(i => (i && i.length >= 1 ? i[0] : "")
            .toUpperCase());
};
